import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  containerLocation: {
    maxWidth: "150px",
  },
  subtitle: {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 500,
    color: "#465869",
    fontFamily: "Manrope",
  },
  modal: {
    minWidth: "80vw",
  },
  container: {
    width: "100%",
    fontFamily: "Manrope !important",
    flex: 1,
    flexDirection: "column",
    paddingBottom: "15px",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default styles;
